"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseConfig = void 0;
exports.baseConfig = {
    // TODO: this key will expire on September 28th, 2026.
    licenseKey: 'c462b-2b342-59ef4-1dc1e-5b860',
    functionArgSeparator: ',', // set by default
    // decimalSeparator: '.', // set by default
    // thousandSeparator: '', // set by default
    // arrayColumnSeparator: ',', // set by default
    // arrayRowSeparator: ';', // set by default
    // dateFormats: ['MM/DD/YYYY', 'MM/DD/YY', 'YYYY/MM/DD'],
    dateFormats: ['YYYY-MM-DD'],
    timeFormats: ['hh:mm', 'hh:mm:ss.sss'], // set by default
    nullYear: 30, // set by default
    caseSensitive: false, // set by default
    accentSensitive: true,
    ignorePunctuation: false, // set by default
    localeLang: 'en', // set by default
    useWildcards: true, // set by default
    useRegularExpressions: false, // set by default
    matchWholeCell: true, // set by default
    useArrayArithmetic: true,
    ignoreWhiteSpace: 'any',
    evaluateNullToZero: true,
    leapYear1900: true,
    nullDate: { year: 1899, month: 12, day: 31 },
    // this is by default true for excel
    smartRounding: false,
};
//# sourceMappingURL=config.js.map